import React from 'react';
import { AiAssistPill } from './EditorShell';
import { ReportSummary, type ReportSummaryData } from './ReportSummary';
import type { EditorStep } from './editorSteps';

interface StepReviewProps {
  data: ReportSummaryData;
  ministryLabel: string;
  canEdit: boolean;
  onEdit: (step: EditorStep) => void;
  onOpenAi: () => void;
  isSubmitting: boolean;
  onSubmit: () => void;
}

export const StepReview: React.FC<StepReviewProps> = ({
  data,
  ministryLabel,
  canEdit,
  onEdit,
  onOpenAi,
  isSubmitting,
  onSubmit,
}) => (
  <div className="flex-1 min-h-0 overflow-y-auto px-4 py-5 space-y-4 animate-step-in">
    <div className="rounded-2xl bg-gradient-to-br from-primary-50 to-indigo-50/50 border border-primary-100 px-4 py-4">
      <h2 className="text-lg font-bold text-gray-900">Review &amp; send</h2>
      <p className="text-sm text-gray-600 mt-1">
        Take a moment to review your {ministryLabel} report before sharing with your team.
      </p>
      {canEdit && (
        <div className="mt-3">
          <AiAssistPill onClick={onOpenAi} />
        </div>
      )}
    </div>

    <ReportSummary data={data} ministryLabel={ministryLabel} onEdit={canEdit ? onEdit : undefined} />

    {canEdit && (
      <button
        type="button"
        onClick={onSubmit}
        disabled={isSubmitting}
        className="w-full py-4 rounded-2xl bg-emerald-600 text-white text-base font-semibold hover:bg-emerald-700 disabled:opacity-50 min-h-touch shadow-lg shadow-emerald-600/20"
      >
        {isSubmitting ? 'Sending…' : 'Submit report'}
      </button>
    )}
  </div>
);
